import React from 'react'
import { X } from 'lucide-react'
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogTitle,
} from '@edvi-tech/ui/dialog'
import { Button } from '@edvi-tech/ui/button'

interface AppDownloadNudgeDialogProps {
  isSticky: boolean
  open: boolean
  onClose: () => void
  onOpenApp: () => void
  onContinueWeb: () => void
}

const AppDownloadNudgeDialog: React.FC<AppDownloadNudgeDialogProps> = ({
  isSticky,
  open,
  onClose,
  onOpenApp,
  onContinueWeb,
}) => (
  <Dialog
    open={open}
    onOpenChange={(next) => {
      if (!next && !isSticky) onClose()
    }}
  >
    <DialogContent
      className="edvi-dlg-content--sm edvi-app-nudge gap-0 rounded-t-2xl p-0 sm:rounded-2xl"
      showCloseButton={false}
      aria-describedby={undefined}
    >
      <DialogTitle className="sr-only">Download the edvi app</DialogTitle>

      {!isSticky ? (
        <DialogClose asChild>
          <button
            type="button"
            className="edvi-dlg__close edvi-app-nudge__close"
            aria-label="Close"
            onClick={onClose}
          >
            <X size={18} strokeWidth={2.25} />
          </button>
        </DialogClose>
      ) : null}

      <div className="edvi-app-nudge__hero" aria-hidden>
        <img
          className="edvi-app-nudge__logo"
          src="/logo192.png"
          alt=""
        />
      </div>

      <div className="edvi-app-nudge__body">
        <p className="edvi-app-nudge__eyebrow">Get the edvi app for</p>
        <p className="edvi-app-nudge__title">
          Smoother, faster, better experience and performance
        </p>
        <p className="edvi-app-nudge__sub">Never miss an update.</p>
      </div>

      <DialogFooter className="edvi-app-nudge__footer">
        <Button type="button" className="edvi-app-nudge__primary" onClick={onOpenApp}>
          Download the app now
        </Button>
        {!isSticky ? (
          <Button
            type="button"
            variant="ghost"
            className="edvi-app-nudge__secondary"
            onClick={onContinueWeb}
          >
            Continue on web
          </Button>
        ) : null}
      </DialogFooter>
    </DialogContent>
  </Dialog>
)

export default AppDownloadNudgeDialog
